import React from 'react';
import { connect } from 'react-redux'
import DatePicker from "react-datepicker";
import { fetchNationalRegistryNamespacedString } from '../../api/national-registry/actions'
import { createEmployer } from '../../api/employers/actions';
import { getEmployerStartDate } from '../../utils'
import moment from 'moment';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import is from 'date-fns/locale/is';
registerLocale('is', is)

const kennitala = require('kennitala')

class EmployerModal extends React.Component {

    constructor(props) {
        super(props)

        
        this.state = {
            search: '',
            startDate: getEmployerStartDate().toDate(),
            employerArray: [],
            selected: false,
            minDate: moment.utc().endOf('month').toDate(),
            startDateUpdated: false,
        }

        this.submitEmployer = this.submitEmployer.bind(this)
        this.onChangeDate = this.onChangeDate.bind(this)
        this.shouldBeDisabled = this.shouldBeDisabled.bind(this)
        this.companySelect = this.companySelect.bind(this)
        this.startDate = React.createRef()
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps.nationalRegistryNamespaced.employerStr){
            return { employerArray: nextProps.nationalRegistryNamespaced.employerStr.data }
        }
        return { }
    }

    componentDidMount(){
        initialInputState();
        let that = this;
        $(this.props.id).on('hidden.bs.modal', function () {
            that.clearModal();
        });
    }

    componentDidUpdate(prevProps, prevState){
        initialInputState();
        const {healthQuestions, customerId} = this.props;
        if (healthQuestions && healthQuestions.groups && healthQuestions.groups[customerId] && healthQuestions.groups[customerId].VID && healthQuestions.groups[customerId].VID.VID && healthQuestions.groups[customerId].VID.VID.termination && !this.state.startDateUpdated) {
            if (healthQuestions.groups[customerId].VID.VID.termination.VIDformerFund !== "000") {
                let startDate = moment.utc(this.state.startDate).add(2, 'months').startOf('month').toDate();
                this.setState({startDate: startDate, startDateUpdated: true})
            }
        }
    }

    handleSSN(event) {
        this.setState({
            search: event.target.value,
            selected: false,
            employerObj: undefined,
        })

        let onlyLookup = true;
        
        if (kennitala.isValid(event.target.value)) {
            this.props.dispatch(fetchNationalRegistryNamespacedString(kennitala.clean(event.target.value), onlyLookup, "employerStr"))
        } else if(event.target.value){
            var cleanString = event.target.value.replace(/[\*]/g, "");
            cleanString += "*"
            this.props.dispatch(fetchNationalRegistryNamespacedString(cleanString, onlyLookup, "employerStr"))
        } else if(!event.target.value){
          this.clearModal()
        }

    }

    clearModal(){
        setTimeout(() => {
            delete this.state.employerObj;
            this.setState({
                ...this.state,
                search: '',
            });
        }, 500)
    }

    onChangeDate(date) {
        this.setState({startDate: moment.utc(date).toDate()})
    }

    submitEmployer() {
        let startDate = this.state.startDate

        let employer = {
            ...this.state.employerObj,
            contractType: 'VID'
        }

        Promise.resolve(this.props.dispatch(createEmployer(this.props.customerId, employer, moment.utc(startDate).format("DD.MM.YYYY"))))
        .then(this.clearModal())
    }

    shouldBeDisabled(){
        let disabledBtn = true;
        if (this.state.employerObj) {
            disabledBtn = false
        }
        return disabledBtn;
    }

    companySelect(selected){
        this.setState((state, props) => ({
            employerObj: selected,
            selected: true
        }))
    }

    render() {


        return (
            <div className="modal employer-modal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel"
                aria-hidden="true" id={this.props.id}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                        </div>
                        <div className="modal-body">
                            <form>
                            <div className={(this.state.employerObj && this.state.employerObj.OrgId) ? "container-fluid employer-form ssn-confirm" : "container-fluid employer-form"} id="payer-form">
                                <div className="form-row mb-3">
                                    <div className="form-group">
                                        <input name={"employer-ssn-"+this.props.customerId} id={"employer-ssn-"+this.props.customerId} className="form-control" placeholder=" " value={this.state.search} type="text" onChange={this.handleSSN.bind(this)} autoFocus />
                                        <label htmlFor={"employer-ssn-"+this.props.customerId}>Nafn/kt. launagreiðanda</label>
                                    </div>
                                    <div className="name-container form-group">
                                        {this.state.employerObj && <div className="name">{this.state.employerObj.Name}</div>}
                                    </div>
                                    
                                    { this.state.employerArray && this.state.employerArray.length > 0 && !this.state.selected &&
                                    <>
                                      {(() => {
                                        if(this.state.employerArray.length === 1) {
                                          if (!kennitala.isValid(this.state.search)) {
                                            return this.companySelect(this.state.employerArray[0])
                                          } else if (this.state.employerArray[0].OrgId === kennitala.clean(this.state.search) )   {
                                            return this.companySelect(this.state.employerArray[0])
                                          }
                                        } else {
                                          return (
                                            <div className="employer-list">
                                                {this.state.employerArray.map((item, key) =>
                                                    <li key={item.OrgId} onClick={(e) => this.companySelect(item, e)}>{item.Name} </li>
                                                )}
                                            </div>
                                          )
                                        }
                                      })()}
                                    </>
                                    }
                                </div>
                                <div className="form-row">
                                    <div className="form-group">
                                        <DatePicker
                                            locale="is"
                                            dateFormat="dd.MM.yyyy"
                                            ref={this.startDate}
                                            id="startingday"
                                            className="form-control ml-sm-auto d-block"
                                            name="startDate"
                                            minDate={this.state.minDate}
                                            onChange={this.onChangeDate}
                                            selected={this.state.startDate}
                                            showMonthYearPicker
                                        />
                                        <label className="focused" htmlFor="startingday">Upphafsdagur</label>
                                    </div>
                                </div>
                            </div>
                            </form> 
                            <button disabled={this.shouldBeDisabled()} className="btn btn-primary" type="button" onClick={this.submitEmployer} data-dismiss="modal">Vista launagreiðanda</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

EmployerModal.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        currency: {},
        nationalRegistry: {},
        nationalRegistryNamespaced: {},
        virtualCard: {},
        payers: {},
        employers: {},
        healthQuestions: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.currency = (state.currency === undefined) ? {} : state.currency
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.nationalRegistryNamespaced = (state.nationalRegistryNamespaced === undefined) ? {} : state.nationalRegistryNamespaced
    f.virtualCard = (state.virtualCard === undefined) ? {} : state.virtualCard
    f.payers = (state.payers === undefined) ? {} : state.payers
    f.employers = (state.employers === undefined) ? {} : state.employers
    f.healthQuestions = (state.healthQuestions === undefined) ? {} : state.healthQuestions

    return f;
}

export default connect(mapStateToProps)(EmployerModal);